var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{style:(`position: fixed; left: 50px; right: 50px; bottom: ${
      !_vm.isOnline && _vm.isAuthenticated ? '10' : '-100'
    }px; z-index: 99; text-align: center;`),attrs:{"show":"","variant":"danger"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }